export var IntelligentPhotoCaptureOrientationPermissionStatus;
(function (IntelligentPhotoCaptureOrientationPermissionStatus) {
    IntelligentPhotoCaptureOrientationPermissionStatus["GRANTED"] = "granted";
    IntelligentPhotoCaptureOrientationPermissionStatus["DENIED"] = "denied";
})(IntelligentPhotoCaptureOrientationPermissionStatus || (IntelligentPhotoCaptureOrientationPermissionStatus = {}));
//# sourceMappingURL=IntelligentPhotoCaptureOrientationPermissionStatus.js.map